import { render, staticRenderFns } from "./ara.vue?vue&type=template&id=2b5a1a27"
import script from "./ara.vue?vue&type=script&lang=js"
export * from "./ara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports